import React from 'react';
import PropTypes from 'prop-types';

function Building2Icon({ className = '', ...props }) {
  return (
    <svg fill='none' stroke='currentColor' viewBox='0 0 24 24' className={className} {...props}>
      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z' />
      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2' />
      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2' />
      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M10 6h4' />
      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M10 10h4' />
      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M10 14h4' />
      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M10 18h4' />
    </svg>
  );
}

Building2Icon.propTypes = {
  className: PropTypes.string,
};

export default Building2Icon;
